import { FieldHtmlNameUtil, Trans } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';

export default class HomePageStartSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-home-page';

  public getVisibleComponents() {
    const result = [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.email),
      }),
    ];
    this.getField(FieldHtmlNameUtil.email).displayVariantType = 'center-placeholder';
    this.getField(FieldHtmlNameUtil.email).name = Trans.byValue('Your business email address');

    return result;
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    return this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.homepageSignup)
      && this.sessionInfo.value.emailCheckCode === null;
  }
}
